import type { Match } from '@uefadigital/panenka';
import { PkIdentifier } from '@uefadigital/panenka-react';
import { useMemo } from 'react';

import { getMatchResultDescription } from './utils';

import { publicPath } from 'signals/publicPath';
import config from 'utils/config';
import { isMatchValid } from 'utils/helpers';

interface MatchDescriptionProps {
  match: Match;
}

const PUBLIC_PATH = publicPath.value;

const MatchDescription = ({ match }: MatchDescriptionProps) => {
  const { primary, secondary } = getMatchResultDescription(match);

  const href = useMemo(() => {
    if (!isMatchValid(match)) {
      return;
    }
    const competition =
      config.competitions.find((item) => item.id === match.competition.id) || config.competitionsDefault;
    const competitionName = competition.name.replace(/ /g, '').toLowerCase();

    return `${PUBLIC_PATH}competitions/${competitionName}/${match.seasonYear}/match/${match.id}`;
  }, [match]);

  return (
    <a href={href} target="_blank" rel="noreferrer">
      <PkIdentifier alignment="left" className="pk-my--m pr-my--0">
        <span
          slot="primary"
          className="pk-text--ui-05 pk-font-size--l pk-font-weight--bold pk-line-height--lg pr-font-size--14 pr-font-weight--500"
        >
          {primary}
        </span>
        <span
          slot="secondary"
          className="pk-text--text-02 pk-font-size--m pk-font-weight--normal pk-line-height--sm pr-font-size--12"
        >
          {secondary}
        </span>
      </PkIdentifier>
    </a>
  );
};

export default MatchDescription;
